import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    console.log('UserCreateModalController connected!')
  }

  open(event) {
    console.log('Open method called!', event)
    const modal = document.getElementById('create_user_modal')
    console.log('Modal element:', modal)
    if (modal) {
      modal.showModal()
    } else {
      console.error('Modal element not found!')
    }
  }

  close() {
    console.log('Close method called!')
    const modal = document.getElementById('create_user_modal')
    if (modal) {
      modal.close()
    }
  }

  closeOnBackdrop(event) {
    const modal = document.getElementById('create_user_modal')
    if (event.target === modal) {
      this.close()
    }
  }
}
